import type { ReactNode } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import type { ArticleCardData } from '@pyranger/types';
import { NAV_MODAL_ID } from '@pyranger/constants';

import { ArticleCard } from './ArticleCard';

/**
 * Displays a list of cards for a collection of Lessons or Projects. Also contains rendering logic
 * for the modal that displays this same list of cards for smaller screens.
 * @param data a list of {@link ArticleCardData} objects
 */
export const ArticleCardList = ({
    children,
    data,
    label,
}: {
    children: ReactNode;
    data: ArticleCardData[];
    label: string;
}) => {
    return (
        <>
            <div className="flex h-full gap-4 overflow-hidden px-6 pb-6 pt-2">
                <div className="hidden h-full flex-none overflow-y-scroll md:block">
                    <ul className="flex flex-col gap-4">
                        {data.map((card) => (
                            <ArticleCard key={card.href} {...card} />
                        ))}
                    </ul>
                </div>
                <div className="flex flex-grow justify-center overflow-y-scroll rounded-lg border border-base-300 p-4">
                    {children}
                </div>
            </div>
            <dialog
                id={NAV_MODAL_ID}
                className="modal ml-4 justify-start backdrop:bg-white/50 dark:backdrop:bg-black/70"
            >
                <div className="modal-box absolute left-2 top-[122px] max-h-[calc(100vh-146px)] w-[274px] translate-y-0 rounded-lg border border-slate-400 bg-zinc-50 px-4 py-0 pb-4 dark:bg-slate-800">
                    <div className="sticky top-0 z-10 flex items-center justify-between bg-zinc-50 py-4 dark:bg-slate-800">
                        <h3 className="font-body text-base uppercase text-gray-400 dark:text-gray-300">
                            {label}
                        </h3>
                        <form method="dialog" className="flex justify-end">
                            <button className="text-slate-800 dark:text-zinc-50">
                                <XMarkIcon width={24} height={24} />
                            </button>
                        </form>
                    </div>
                    <ul className="flex flex-col gap-4">
                        {data.map((card) => (
                            <ArticleCard key={card.href} {...card} />
                        ))}
                    </ul>
                </div>
            </dialog>
        </>
    );
};
